export const initOptions: any = {
    realm: 'g-vu',
    url: 'https://account.g-vu.ovh/',
    clientId: 'web-gvu-' + process.env.VUE_APP_DB_STATUS,
    logoutRedirectUri: process.env.VUE_APP_URL + '/home',
};
